import './About.scss';

const About = () => {
    return (
        <div>

        </div>
    )
}

export default About
